<template>
    <div id="fullcontent">

      <LeftMenuCampus :expanded="menu_expanded" @closeMenu="closeMenu" :key="this.$route.fullPath" ></LeftMenuCampus>

      <div class="toogle-content">
        <div class="toggle-menu" :class="{'opened':menu_expanded}" @click="toggleMenu"></div>
      </div>

      <div id="main-content" :class="{'expanded': menu_expanded}">
        <Topbar></Topbar>
        <section id="container"> <router-view/> </section>
      </div>

  </div>
</template>

<script>

  import LeftMenuCampus from "@/components/domain/home/LeftMenuCampus";
  import Topbar from "@/components/layout/Topbar";

export default {
    components: {
        LeftMenuCampus,
        Topbar
    },
    data(){
        return {
            menu_expanded: false,
        }
    },
    methods: {
        closeOverlay(){
            this.$store.commit('setOverlayVisible',false);
        },
        toggleMenu(){
            var self = this;
            this.menu_expanded ? this.$overlay.hide() : this.$overlay.show({ callClick: function(){
              self.$overlay.hide();
              self.menu_expanded = false;
            } });
            this.menu_expanded = !this.menu_expanded;
          },
        closeMenu(){
            this.$overlay.hide();
            this.menu_expanded = false;
        },
    },
    created(){
        this.$store.commit('setMenuVisible', false);
    },
    watch: {
      '$route': 'closeMenu',
    }
}
</script>

<style lang="scss" scoped>

  #fullcontent {
    width: 100%;
    height: 100%;
  }

  .toggle-menu {
    display: none;
  }

  #main-content {
    height: 100%;
    width: calc( 100% - 300px );
    margin-left: 300px;
    float: left;
    overflow: hidden;
    display: block;
    position: relative;
    overflow: auto;
    // padding: 25px;
    background-color: #fff;

    &.expanded {
      // width: calc( 100% - 300px );
      // margin-left: 300px;
    }

    #container {
      height: 100%;
      margin-top: 0px;
      padding: 25px 30px;
      padding-top: 0px;
    }


    @include media(">phone", "<tablet") {
      width: 100%;
      margin-left: 0;
    }
  }

  @include media(">phone", "<tablet") {

    #main-content.expanded {
      width: 100%;
      margin-left: 0;
    }

  #main-content {
    #container {
      height: auto !important;
      padding: 25px 20px;
      padding-bottom: 50px;
      padding-top: 0;
    }
  }

  #content {
    padding-top: 0;
  }

  .toggle-menu {
    @include background( $image: img('hmenu.svg'), $size: 26px );
    position: fixed;
    top: 0;
    left: 0;
    width: 50px;
    height: 50px;
    z-index: 30;
    display: block;
    transition-duration: 0.2s;

    &.opened {
      background-image: img('hmenu_light.svg');
      left: unset;
      right: 0;
    }
  }
    

  }

</style>